import gql from 'graphql-tag';

export const gqlGetQuery = gql`
  query getCntContributionOlds($limit: Int, $offset: Int, $order: String, $where: String) {
    getCntContributionOlds(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        contributorId
        year
        periodId
        invoiceFileId
        contributor {
          id
          name
          addressLine1
          addressArea
          vatNumber
          taxOffice
        }
        contributionperiod {
          id
          name
          months
          periodStartDay
          periodStartMonth
          periodEndDay
          periodEndMonth
          periodEndYearAdd
          contributionsPeriodgroup {
            id
            name
          }
        }
        series {
          id
          name
        }
      }
      recordCount
    }
  }
`;

export const gqlGetFilesRepositoryFileUrlById = gql`
  query getFilesrepositoryFileUrlById($id: Int) {
    getFilesrepositoryFileUrlById(id: $id)
  }
`;
